// Dubai guide: duct cleaning vs coil cleaning.
const content = {
    slug: 'ac-duct-cleaning-vs-coil-cleaning',
    title: 'AC Duct Cleaning vs Coil Cleaning in Dubai | Which Do You Need?',
    description: (c) =>
        `Duct cleaning or coil cleaning? What each fixes in a Dubai apartment, how often you need them, and why the coil usually comes first. Coil wash from ${c.money(c.tables.chemicalWash[0].ducted)}.`,
    eyebrow: 'Dubai · AC guide',
    h1: 'AC Duct Cleaning vs Coil Cleaning: Which Does Your Apartment Need?',
    lead: 'Smell, dust and weak airflow are often blamed on "dirty ducts". In most Dubai apartments the real culprit is the coil inside the unit - which is cheaper and quicker to fix. Here is how to tell the difference.',
    datePublished: '2026-10-03',
    image: 'blog/living/dirty-aircon-evaporator-coil.jpg',
    imageAlt: 'Dirty AC coil compared with a clean duct',
    summary: {
        title: 'In short',
        items: [
            'Coil cleaning fixes smells, weak airflow and poor cooling - the usual complaints.',
            'Duct cleaning removes dust from the ducts and diffusers - visible dust puffing out of vents is the main sign.',
            'Most homes need a coil wash yearly and duct cleaning only every few years, or when moving in.',
        ],
    },
    sections: [
        {
            title: 'What each job cleans',
            cards: [
                { title: 'Coil cleaning', body: 'The indoor unit: filter, cooling coil, blower wheel and drain tray. Removes dust cake, mould and slime.' },
                { title: 'Duct cleaning', body: 'The supply and return ducts above the ceiling and the diffusers in each room. Removes loose dust and debris.' },
            ],
        },
        {
            title: 'Match the symptom',
            table: {
                columns: [
                    { key: 'symptom', label: 'Symptom' },
                    { key: 'likely', label: 'Most likely cause' },
                    { key: 'fix', label: 'Fix' },
                ],
                rows: [
                    { symptom: 'Musty smell when AC starts', likely: 'Mould on coil and blower', fix: 'Coil chemical wash' },
                    { symptom: 'Air cool but weak', likely: 'Clogged filter or coil', fix: 'Cleaning or coil wash' },
                    { symptom: 'Water at a ceiling grille', likely: 'Blocked drain tray', fix: 'Cleaning with drain flush' },
                    { symptom: 'Dust puffing from diffusers', likely: 'Dusty ducts', fix: 'Duct cleaning' },
                    { symptom: 'Black marks around diffusers', likely: 'Mould from coil, or condensation at diffuser', fix: 'Coil wash first; check insulation' },
                ],
            },
        },
        {
            title: 'Why start with the coil',
            paragraphs: [
                'The coil is where air is cooled and dehumidified, so it is always wet - the ideal place for dust to stick and mould to grow. Ducts carry already-filtered, conditioned air and stay comparatively dry. Clean the coil and the source of most smells disappears; clean only the ducts and the dirty coil keeps blowing the same air through freshly cleaned ducts.',
                'Duct cleaning is still worth doing when you move into a previously occupied apartment, after renovation work that created dust, or when you can see dust blowing out of diffusers.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How often should AC ducts be cleaned in Dubai?',
            answer: 'Every few years for most apartments, and when moving in or after renovations. Coils need attention far more often - roughly yearly.',
        },
        {
            question: 'Does StringsSG do duct cleaning?',
            answer: 'Our Dubai service covers the unit - cleaning, coil wash and deep cleaning. If your technician sees ducts that need cleaning, they will tell you.',
        },
    ],
    cta: {
        title: 'Start with the coil',
        body: (c) => `Coil chemical wash for a ducted unit: ${c.money(c.tables.chemicalWash[0].ducted)}.`,
        href: '/ae/ac-service-dubai/ac-coil-chemical-wash',
        label: 'See coil cleaning',
    },
}

export default content
